<template>
    <div class="topic-view">

        <div class="paginator-container"><Paginator v-if="pageReady" :pageData = "pageData" /></div>

        <div class="topic-container">
            <component :is="postEditorConfig.component" v-bind="{data: postEditorConfig.data, callbacks: postEditorConfig.callbacks, topicStatus: topicInfo.status}"></component>
            <component :is="editComponent" v-bind="{topicInfo: topicInfo, tagsSel:topicTags}"></component>
            <PostsListItem v-for="(post, index) in posts" :key="post.postID" :postIndex="index" :post="post" :topicInfo="topicInfo" :tags="topicTags"></PostsListItem>
        </div>

        <div class="paginator-container bottom"><Paginator v-if="pageReady" :pageData = "pageData" /></div>

    </div>
</template>


<script>

    import PostsListItem from '../../components/Posts/PostsListItem.vue'
    import TopicControls from '../../components/Topics/TopicControls.vue'    
    import EditTopic from '../../components/Topics/TopicEditor.vue'
    import PostEditor from '../../components/Posts/PostEditor.vue'
    import Paginator from '../../components/Widgets/Paginator.vue'
    import api from '../../api/api'
    import settings from '../../modules/settings'
    import common from '../../modules/common'
    
    export default {

        props: ['id', 'requestedPage'],

        data() {
            return {
                pageReady: false,
                posts: null,
                topicInfo: {},
                topicTags: null,
                postEditorConfig: {},
                editComponent: null,
                pageData: {
                    currentPage: null,
                    pageSize: null,
                    totalItems: null
                }
            }
        },
        components: {
            PostsListItem,
            TopicControls,
            PostEditor,
            EditTopic,
            Paginator
        },
        watch: {
            $route: function(to, from) {
                if(to.name === from.name) {
                    window.location.reload();
                }
            },
        },
        computed: {
            sortOrder: () => {
                return settings.user.getPostOrder();
            },
            getTopicStatus() {
                if(!this.topicInfo) return "";
                switch(this.topicInfo.status) {
                    case 0: return "(Deleted)";
                    case 1: return "(Pending Approval)";
                    case 2: return "(Normal)";
                    case 3: return "(Moderated)";
                    case 4: return "(Locked)";
                }
            }
        },
        methods: {

            // topic editing
            openTopicEditor: function() {
                this.editComponent = EditTopic;
            },
            closeTopicEditor: function() {
                this.editComponent = null;
            },
            submitTopicEdit: function(data) {
                api.post('/topics/' + this.id + '/edit', {
                    topicID: parseInt(this.id),
                    title: data.title,
                    boardID: data.boardID,
                    status: parseInt(data.status) || parseInt(this.topicInfo.status),
                    tags: data.tags,
                    pinned: data.pinned != undefined ? data.pinned : this.topicInfo.pinned,
                })
                .then(() => {
                    this.closeTopicEditor();
                    this.refreshTopicInfo();
                });
            },

            // topic deletion
            confirmDeleteTopic: function() {
                if (confirm(
                    'Are you sure you want to delete topic ' 
                    + this.id 
                    + ': ' + this.topicInfo.title)) {
                        this.deleteTopic();
                    }
            },
            deleteTopic: function() {
                api.delete('/topics/' + parseInt(this.id))
                .then(() => {
                    this.$router.replace('/');
                }).catch(function(error) {
                    this.modalIsConfirm = false;
                    this.modalText = error
                    this.modalClose = () => {this.showPopup = false;};
                    this.showPopup = true;
                });
            },

            // topic replies
            topicReply: function() {
                this.postEditorConfig.data.mode = 'reply';
                this.postEditorConfig.data.content = null,
                this.postEditorConfig.component = PostEditor;
            },
            closeReply: function() {
                this.postEditorConfig.component = null;
            },            
            submitReply: function(content) {
                api.post('/topics/' + this.id + '/reply', {
                    topicID: parseInt(this.id),
                    content: content,
                    memberID: this.$store.getters.user.id
                })
                .then(() => {
                    this.closeReply();
                    this.refreshPosts();
                }).catch(function(error) {
                    this.modalIsConfirm = false;
                    this.modalText = error
                    this.modalClose = () => {this.showPopup = false;};
                    this.showPopup = true;
                });
            },


            // view refreshing
            refreshPosts: function() {
                this.getPage(this.pageData.currentPage);
                this.scrollToLast();
            },

            scrollToLast: function() {                
                // last due to reply might not be on this page
                // let's move to next page if needed
                const latestPostOnPage = Math.max(...(this.posts.map(po => po.postID)));
                if (this.isPostInCurrentPage(latestPostOnPage)) {
                    setTimeout(() => {
                        let elem = document.getElementById('post-'+ latestPostOnPage);
                        if(elem) elem.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                    }, 0);
                } else {
                    this.$router.push({ path: `/topics/${this.id}/posts/${latestPostOnPage}`});
                }
                
            },

            scrollToPost: function(postID) {
                if (this.isPostInCurrentPage(postID)) {
                    setTimeout(() => {
                        let elem = document.getElementById('post-' + postID);
                        if (elem) elem.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                    }, 0);
                } else {
                    this.$router.push({ path: `/topics/${this.id}/posts/${postID}`});
                }   
            },

            
            isPostInCurrentPage: function (postID) {
                var x = this.posts.map(p => p.postID).indexOf(parseInt(postID));
                return x >= 0;
            },

            refreshTopicInfo: function() {
                api.get('/topics/' + this.id)
                .then(response => {
                    this.setTopicInfo(response.data);
                });                
            },


            setTopicInfo: function(data) {

                this.topicTags = data.tags;
                
                this.topicInfo = {
                    topicID: this.id,
                    boardID: data.topicInfo.boardID,
                    boardName: data.topicInfo.boardName,
                    title: data.topicInfo.title,
                    owningMemberID: data.topicInfo.owningMemberID,
                    startDateUTC: data.topicInfo.startDateUTC,
                    status: data.topicInfo.status,
                    postCount: data.posts.length,
                    boardType: data.topicInfo.boardType,
                    boardStatus: data.topicInfo.boardStatus,
                    tags: data.tags,
                    pinned: data.topicInfo.pinned,                                    
                }

                var crumb = common.breadcrumb.create([
                    { url: '/', text: 'UtterAccess' },
                    { url: '/boards/' + this.topicInfo.boardID, text: this.$options.filters.decodeHtml(this.topicInfo.boardName) },
                    { url: '/topics/' + this.id, text: 'View Topic' }
                ]);
                
                switch(this.topicInfo.boardStatus) {
                    case 0: {
                        crumb = crumb + " (Inactive)";
                        break;
                    }
                    case 2: {
                        crumb = crumb + " (Inactive)";
                        break;
                    }
                }
                this.$store.dispatch("breadcrumb", crumb);
                this.$store.dispatch("currentTopicStatus", this.getTopicStatus)
                this.$store.dispatch('createTopicBoardContextID', this.topicInfo.boardID);
            },



            getPage: function(pageNumber, completedCallback) {

                if (!pageNumber) pageNumber = this.pageData.currentPage;

                let pageSize = settings.user.getPostsPerPage();

                api.get('/topics/' + this.id, {
                    params: {
                        topicID: parseInt(this.id),
                        pageSize: pageSize,
                        requestedPage: pageNumber,
                        sortOrder: this.sortOrder
                    }
                }).then((response) => {     
                    
                    this.posts = this.sortOrder === 'desc' ? response.data.posts.reverse() : response.data.posts;
                    
                    this.pageData = {
                        getPage: this.getPage,
                        currentPage: pageNumber,
                        pageSize: pageSize,
                        totalItems: response.data.posts.length > 0 ? response.data.posts[0].totalRows : 0
                    }

                    if (completedCallback) {
                        completedCallback(response.data);                      
                    }

                    this.pageReady = true;
                });
            }

        },

        mounted() {

            var bc = common.breadcrumb.create([
                { url: '/', text: 'UtterAccess' },
                { text: 'View Topic' }
            ]);
            this.$store.dispatch("breadcrumb", bc);
        
            var pageNumber = this.requestedPage || 1;
            var postID = this.$route.params.postId || null;

            this.getPage(pageNumber, (topicInfo) => {
                this.setTopicInfo(topicInfo);
                if (postID) this.scrollToPost(postID);
            });

            // configure post editor
            let postEditorConfig = {
                component: null,
                data: {
                    mode: 'reply',
                    content: null
                },
                callbacks: {
                    close: this.closeReply,
                    submit: this.submitReply
                }
            }
            this.postEditorConfig = postEditorConfig;

            api.post('/topics/' + this.id + '/incrementViewCount');

            if (localStorage.getItem('token')){
              api.post('/topics/' + this.id + '/updateRead');
            }

        },

        
        beforeRouteLeave(to, from, next) {
            this.$store.dispatch('createTopicBoardContextID', null);
            next();
        }

    }

</script>
